import { render, staticRenderFns } from "./ModifyWordScorePopup.vue?vue&type=template&id=920502a4"
import script from "./ModifyWordScorePopup.vue?vue&type=script&lang=js"
export * from "./ModifyWordScorePopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports